import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "v-table" }
const _hoisted_2 = ["onMouseenter"]
const _hoisted_3 = ["onClick"]

import { useUiStore } from '@/stores/ui';


type Column = {
  title?: string,
  fallback?: string,
  width?: number,
  class?: string,
  thClass?: string,
  tooltip?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VTable',
  props: {
    columns: null,
    data: null,
    key: null
  },
  emits: ["onitemclick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onitemclick', item: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { 
  columns: { [ key: string ]: Column },
  data: Array<any>,
  key?: string
}



const getStyle = (column: Column) => {
  return {
    width: column.width && (column.width + 'px'),
    minWidth: column.width && (column.width + 'px')
  }
}



const uiStore = useUiStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, key) => {
          return (_openBlock(), _createElementBlock("th", {
            key: key,
            style: _normalizeStyle(getStyle(column)),
            class: _normalizeClass(column.thClass),
            onMouseenter: ($event: any) => (column.tooltip && _unref(uiStore).openTooptip($event, column.tooltip))
          }, _toDisplayString(column.title ?? key), 47, _hoisted_2))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: props.key? item[props.key]: index,
          onClick: ($event: any) => (emit('onitemclick', item))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column, key) => {
            return (_openBlock(), _createElementBlock("td", {
              key: key,
              style: _normalizeStyle(getStyle(column)),
              class: _normalizeClass(column.class)
            }, [
              _renderSlot(_ctx.$slots, key, {
                item: item,
                cell: item[key],
                index: index
              }, () => [
                _createTextVNode(_toDisplayString(item[key] ?? column.fallback), 1)
              ])
            ], 6))
          }), 128))
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})